import "./assets/scss/seeks.scss";
import "./assets/scss/customizer.scss";

import React from "react";
import * as SettingSelector from "./store/setting/selectors";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { setSetting } from "./store/setting/actions";
import { useSelector } from "react-redux";
const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

function App(props) {
  const dispatch = useDispatch();
  const themeScheme = useSelector(SettingSelector.theme_scheme);
  dispatch(setSetting());
  
  const [mode, setMode] = React.useState(
    themeScheme === "light" ? "light" : "dark"
  );

  React.useEffect(() => {
    const newMode = themeScheme === "light" ? "light" : "dark";
    if (mode !== newMode) {
      setMode(newMode);
    }
  }, [themeScheme, mode]);

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        const newMode = mode === "light" ? "dark" : "light";
        setMode(newMode);
        },
    }),
    [mode]
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <div className="App">
          {/* <IndexRouters /> */}
          {props.children}
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
